/**
 * @constant {Object}
 * @desc List of entity names used in analytics events
 */
export var ENTITY_NAME = {
  MARKETPLACE_SEARCH: 'marketplace_search'
};
/**
 * @constant {Object}
 * @desc Different event types to set event_type in analytics events
 */

export var EVENT_TYPE = {
  FORM_IMPRESSION: 'form_impression',
  MARKETPLACE_OFFERS_IMPRESSION: 'marketplace_offers_impression',
  MARKETPLACE_SEARCH_UPDATED: 'marketplace_search_updated'
};
/**
 * @constant {Object}
 * @desc Different form names used for form events
 */

export var FORM_NAME = {
  MARKETPLACE_SEARCH: 'marketplace_search'
};
/**
 * @constant {Object}
 * @desc Different section names used in analytics events
 */

export var SECTION_NAME = {
  MARKETPLACE_SEARCH: 'marketplace_search',
  MARKETPLACE_SEARCH_SUGGESTIONS: 'marketplace_search_suggestions'
};
/**
 * Get the legacy name for legacy events.
 * CC uses a product specific name for backwards compatibility in data.
 *
 * @param productType
 */

export var getLegacySearchName = function getLegacySearchName(productType) {
  return productType === 'credit_cards' ? 'credit-card-search' : 'marketplace-search';
};